export default __webpack_public_path__ + "static/media/video.a7e5bf97.ogv";